import { useEffect, useState } from 'react'
import CustomModal from './modal'

export const GlobalVideoModal = () => {
  const [showModal, setShowModal] = useState(false)
  const [videoUrl, setVideoUrl] = useState('')

  useEffect(() => {
    // Expose global function for Builder (accept full URL or just ID)
    window.__openVideoModal = (input) => {
      const url = resolveVideoUrl(input)
      if (url) {
        setVideoUrl(url)
        setShowModal(true)
      }
    }

    // Cleanup
    return () => {
      window.__openVideoModal = undefined
    }
  }, [])

  // Helper: convert ID to URL if needed
  const resolveVideoUrl = (input) => {
    if (!input) return ''
    const isFullUrl = input.includes('youtube.com') || input.includes('youtu.be')
    return isFullUrl
      ? input
      : `https://www.youtube.com/embed/${input}?autoplay=1&modestbranding=1&rel=0`
  }

  return (
    <>
      {showModal && (
        <CustomModal
          show={showModal}
          onClose={() => setShowModal(false)}
          className="md:w-2/3"
          title=""
        >
          <iframe
            className="video md:min-h-[400px]"
            width="100%"
            height="100%"
            title="Video Modal"
            sandbox="allow-same-origin allow-forms allow-popups allow-scripts allow-presentation"
            src={videoUrl}
            allow="autoplay; fullscreen"
            frameBorder="0"
            allowFullScreen
          />
        </CustomModal>
      )}
    </>
  )
}
